<template>
  <section class="f-1" id="home">
    <div class="f-top-kv-content">
      <div class="kv_bg">
        <m-img class="img_bg" src="@/v2/auto/assets/image/1/bg.jpg" />
        <m-img
          class="flymeauto_title"
          src="@/v2/auto/assets/image/1/1_flymeauto.svg"
        />
        <div class="slogan_title">
          <img src="@/v2/auto/assets/image/1/2.svg" />
          <VideoMask :videoSrc="videoSrc">
            <div class="promotional_btn" ref="promotional">
              观看宣传片
              <VideoPlay />
            </div>
          </VideoMask>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { resizeHandle } from '@/v2/auto/bus_key'
import VideoMask from '@/components/video-mask.vue'
import videoSrc from '@/v2/auto/assets/video/0/0.mp4'
import VideoPlay from '@/v2/auto/assets/image/0/video_play.vue'
export default {
  components: {
    VideoMask,
    VideoPlay,
  },
  data() {
    return {
      videoSrc,
      preload_: true,
    }
  },
  mounted() {
    this.initHeight()
    this.$event.on(resizeHandle, () => {
      this.initHeight()
    })
    const tl = this.$gsap.timeline({
      scrollTrigger: {
        trigger: '.f-top-kv-content',
        start: 'top top',
        end: 'bottom center',
        scrub: 1,
        pin: true,
        snap: {
          snapTo: 'labelsDirectional', //
          duration: { min: 0, max: 0.5 },
          delay: 0,
          inertia: false,
        },
        onUpdate: (self) => {
          const promotional = this.$refs.promotional
          if (self.progress > 0.5) {
            promotional?.setAttribute('style', 'visibility: visible')
          } else {
            promotional?.setAttribute('style', '')
          }
        },
        // markers: true
      },
    })
    tl.addLabel('start')
    tl.to('.flymeauto_title', {
      ease: 'power2.in',
      opacity: 0,
    })
    tl.to('.slogan_title', {
      ease: 'power2.out',
      opacity: 1,
    })
    tl.addLabel('end')
  },
  methods: {
    initHeight() {
      if (isPad) {
        this.$gsap.set('.kv_bg', {
          height: `${window.innerHeight}px`,
        })
        this.$gsap.set('.f-top-kv-content', {
          height: `${window.innerHeight}px`,
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.f-1 {
  width: 100%;
  position: relative;
  z-index: 90;
  background-color: #000;

  .f-top-kv-content {
    height: 100vh;

    .kv_bg {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      width: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      .img_bg {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: -1;
        object-fit: cover;
      }
    }

    .flymeauto_title {
      width: 639px;
      position: absolute;
      top: 35%;
    }

    .slogan_title {
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        position: absolute;
        top: 35%;
        width: 761px;
      }
    }
  }
  .promotional_btn {
    visibility: hidden;
    position: absolute;
    cursor: pointer;
    font-size: 18px;
    color: #000;
    width: 160px;
    border-radius: 100px;
    background-color: #ffffffcf;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 0;
    gap: 10px;
    bottom: 10%;
    transform: translate(-50%, 0);
  }
}
</style>
